import React, { useEffect, useState } from "react";
import Container from "olive-react-myoneui/lib/Container";
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import CourseEventWithHover from "./courseEventWithHover";
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { commonModuleName } from "../../../constants/config";

function CourseHoverableListing({ filter, allCourses, offsetDifference, miscellaneous, paths, enrolled }) {
  const { t } = useTranslation(commonModuleName);
  var scrollTimer = null;
  const [currentOffset, setCurrentOffset] = useState(0);
  const perPageLimit = 12;
  const loadMore = () => {
    setCurrentOffset((state) => (state + perPageLimit));
  }
  const [searchParams, setSearchParams] = useSearchParams();
  const [displayCourses, setDisplayCourses] = useState([]);
  const getFilteredCourses = (obj) => {
    if (filter == "packages") {
      let filteredCourses = obj.allCourses.filter((elem) => obj.type.includes(elem.item_type));
      filteredCourses = filteredCourses.filter(elem => {
        return elem.c_bundle_type === "1";
      });
      return filteredCourses.filter((elem) => enrolled[elem.item_type] ? !enrolled[elem.item_type].includes(elem.item_id) : true);
    }
    if (miscellaneous.bulk_purchase) {
      return obj.allCourses.filter((elem) => obj.type.includes(elem.item_type));
    }
    return obj.allCourses.filter((elem) => obj.type.includes(elem.item_type) && (enrolled[elem.item_type] ? !enrolled[elem.item_type].includes(elem.item_id) : true));
  }
  const [searchString, setSearchString] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const init = async () => {
    let type = [];
    let tabId = "";
    switch (filter) {
      case "all":
        type = ["course", "bundle", "blended", "offline", "online", "packages"];
        tabId = "#allcourses-tabs-tab-course_filter_0";
      break;
      case "blended":
        type = ["blended"];
        tabId = "#allcourses-tabs-tab-course_filter_1";
      break;
      case "online":
        type = ["course", "bundle", "online"];
        tabId = "#allcourses-tabs-tab-course_filter_4";
      break;
      case "offline":
        type = ["offline"];
        tabId = "#allcourses-tabs-tab-course_filter_2";
      break;
      case "events":
        type = ["booking_event"];
        tabId = "#allcourses-tabs-tab-course_filter_3";
      break;
      case "packages":
        type = ["bundle"];
        tabId = "#allcourses-tabs-tab-course_filter_5";
        break;
    }
    let dC = getFilteredCourses({ allCourses: allCourses, type: type });
    if (searchParams.get('search') || searchParams.get('categoryids')) {
      if (searchParams.get('search') && searchParams.get('categoryids')) {
        dC = dC.filter(elem => (elem.item_name.toLowerCase().indexOf(searchParams.get('search').toLowerCase()) > -1) && (elem.item_category == searchParams.get('categoryids')));
      } else if (searchParams.get('search')) {
        dC = dC.filter(elem => elem.item_name.toLowerCase().indexOf(searchParams.get('search').toLowerCase()) > -1);
      } else {
        dC = dC.filter(elem => elem.item_category == searchParams.get('categoryids'));
      }
    }
    setDisplayCourses(dC);
    if (document.querySelector(tabId)) {
      if (dC.length < 1) {
        document.querySelector(tabId).parentNode.style.display = "none";
      } else {
        document.querySelector(tabId).parentNode.style.display = "block";
      }
    }
  };
  const loadMoreCheck = () => {
    document.querySelectorAll(".load-more-courses").forEach((elem) => {
      if (elem.offsetParent && elem.getBoundingClientRect().top < window.innerHeight) {
        elem.click();
      }
    });
  }
  useEffect(() => {
    init();
    window.onscroll = () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        loadMoreCheck();
      }, 100);
    }
  }, []);
  if (document.getElementById("searchId") && (searchParams.get('search') != searchString || searchParams.get('categoryids') != categoryId)) {
    if (searchParams.get('search') == null) {
      document.getElementById("searchId").value = '';
    }
    if (searchParams.get('search') != searchString) {
      setSearchString(searchParams.get('search'));
    }
    if (searchParams.get('categoryids') != categoryId) {
      setCategoryId(searchParams.get('categoryids'));
    }
    init();
  }
  if (displayCourses.length < 1) {
    return (
      <Container className="p-0">
        <Row className="py-4">
          <Col lg={6} md={8} className="mb-4 mx-auto">
            <img className="mt-3" src={paths.assets_url + "themes/ofabee/img/no-courses.svg"} />
            <span className="no-result">{t('oops_no_result_found')}</span>
          </Col>
        </Row>
      </Container>
    )
  }
  return (
    <Container className="p-0">
      <Row className="py-4">
        {
          displayCourses.length < 1 && (
            <Col lg={6} md={8} className="mb-4 mx-auto">
              <img className="mt-3" src={paths.assets_url + "themes/ofabee/img/no-courses.svg"} />
              <span className="no-result">{t('oops_no_result_found')}</span>
            </Col>
          )
        }
        {
          displayCourses.length > 0 && displayCourses.slice(0, perPageLimit + currentOffset).map((course, key) => {
            return (
              <Col lg={3} className="mb-4" key={"course_key_" + key}>
                <CourseEventWithHover
                  course={course}
                  miscellaneous={miscellaneous}
                  offsetDifference={offsetDifference}
                  currentTimeStamp={new Date(miscellaneous.current_date + " " + miscellaneous.current_time).getTime() + offsetDifference}
                  paths={paths}
                />
              </Col>
            );
          })
        }
        {
          displayCourses.length > currentOffset + perPageLimit && (
            <div className="text-center px-1 load-more-courses" onClick={loadMore}></div>
          )
        }
      </Row>
    </Container>
  );
}

export default CourseHoverableListing;
